const StatusBadge = ({ children, className = "" }) => {
  return (
    <span className={`rounded-md px-3 py-1 text-xs font-bold ${className}`}>
      {children}
    </span>
  );
};

const InfoBadge = ({ icon, children, className = "" }) => {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-md border border-white/10 bg-white/10 px-3 py-1 text-xs font-semibold text-neutral-100 ${className}`}
    >
      {icon}
      {children}
    </span>
  );
};

export { StatusBadge, InfoBadge };
